module.exports = __webpack_public_path__ + "videos/participant-testing.ebeada0.mp4";